import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, signIn } = useAuth();

  useEffect(() => {
    // Show success message if redirected from signup
    if (location.state?.message) {
      setSuccessMessage(location.state.message);
    }
  }, [location]);

  useEffect(() => {
    // Redirect if already logged in
    if (user) {
      navigate('/');
    }
  }, [user, navigate]);

  const handleLogin = async (e) => {
    if (e) e.preventDefault();
    
    if (!email.trim()) {
      setError('Please enter your email address');
      return;
    }
    if (!password) {
      setError('Please enter your password');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      await signIn(email, password);
      navigate('/');
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message || 'Invalid email or password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-grid container">
        <div className="login-hero d-none d-md-flex">
          <div className="login-hero-content">
            <div className="brand">
              <img src="https://froomyrsdtspkmaognle.supabase.co/storage/v1/object/public/logos/zilch-testing-store.myshopify.com-1753009531626.png" className='border border-white rounded-3' alt="Zilch Logo" width={48} height={48} />
              <span>Zilch.</span>
            </div>
            <h2>Measure and manage your product carbon footprint.</h2>
            <p>Sign in to import and manage your product library, run product carbon footprint (PCF) assessments, and share results for each SKU.</p>
          </div>
          <div className="login-orb orb-1" />
          <div className="login-orb orb-2" />
          <div className="login-orb orb-3" />
        </div>
        <div className="login-card-wrapper">
          <div className="login-card">
            <div className="brand brand-center d-md-none mb-3">
              <img src="https://froomyrsdtspkmaognle.supabase.co/storage/v1/object/public/logos/zilch-testing-store.myshopify.com-1753009531626.png" className='border border-white rounded-3' alt="Zilch Logo" width={40} height={40} />
              <span>Zilch.</span>
            </div>
            <h1 className="login-title">Welcome back</h1>
            <p className="login-subtitle">Sign in to your dashboard</p>
            <form onSubmit={handleLogin}>
              <div className="form-group">
                <label>Email Address</label>
                <input
                  type="email"
                  className="login-input"
                  placeholder="your.email@company.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  required
                />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input
                  type="password"
                  className="login-input"
                  placeholder="Your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                  required
                />
                <div className="text-center mt-2">
                  <Link to="/forgot-password" className="text-secondary" style={{ fontSize: '0.85rem' }}>
                    Forgot password?
                  </Link>
                </div>
              </div>
              <button
                type="submit"
                className="login-button"
                disabled={loading || !email.trim() || !password}
              >
                {loading ? 'Logging in…' : 'Log In'}
              </button>
            </form>
            
            {successMessage && (
              <div className="alert alert-success mt-3" role="alert">
                {successMessage}
              </div>
            )}
            
            {error && (
              <div className="login-error" role="alert">
                {error}
              </div>
            )}

            <div className="text-center mt-4">
              <small className="text-white">
                Don't have an account?{' '}
                <Link to="/signup" className="zilch-text-green">
                  Create one
                </Link>
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;


